var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.show,"persistent":"","content-class":"dialog sm"}},[_c('change-password-panel',{ref:"panel",attrs:{"dialog":true},on:{"changed":_vm.hide}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }